import UserWelcome from './UserWelcome'

export default UserWelcome
